import React, { useState, useEffect } from "react";
import styles from "./HomePage3PL.module.css";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { useFont } from "../../contexts/FontContext/FontContext";
import ReturnsData from "./ReturnsData/ReturnsData";
import Logo from "../../components/Logo/Logo";

const HomePage3PL = () => {
	const [data, setData] = useState([]);
	const [businessName, setBusinessName] = useState(null);
	const [businessLogo, setBusinessLogo] = useState(null);
	const [dropdownVisible, setDropdownVisible] = useState(false);
	const [selectedButton, setSelectedButton] = useState(null);
	const [searchValue, setSearchValue] = useState("");
	const fontSchemes = useFont();    
    const fontFamilyOne = fontSchemes.scheme_one; 
    const token = localStorage.getItem("authToken"); 
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [revealHeaderButtons, setRevealHeaderButtons] = useState(false);
    const [revealReceiverTitle, setRevealReceiverTitle] = useState(false);
    setTimeout(() => { setRevealReceiverTitle(true); }, 1000);

    useEffect(() => {
    	if (data && !revealHeaderButtons) { setTimeout(() => { setRevealHeaderButtons(true); }, 2000);}
    }, [data])

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => { window.removeEventListener("resize", handleResize); };
    }, []);

    useEffect(() => {
	    const fetchReceiverData = async () => {
	    	try {
		        const response = await fetch(`${apiUrl}/api/get_receiver_data/`, {
		        	method: "GET",
		          	headers: {"Content-Type": "application/json", Authorization: `Bearer ${token}`},
		        });
		        const result = await response.json();
		        setData(result);
		    } catch (err) { console.error("Error fetching receiver data:", err); }
	    };
	    fetchReceiverData();
	}, [token]);

    useEffect(() => {
	    const fetchBusinessNameAndLogo = async () => {
	    	try {
		        
		        const response = await fetch(`${apiUrl}/api/business_details/`, {
		        	method: "GET",
		          	headers: {"Content-Type": "application/json", Authorization: `Bearer ${token}`},
	        });
	        const data = await response.json();
	        setBusinessName(data.business_name);
	        setBusinessLogo(data.logo_filename);
	    	} catch (err) { console.error("Error fetching business details:", err); }
	    };
	    fetchBusinessNameAndLogo();
	}, []);

	const exportToCSV = (data, filename = "export.csv") => {
		if (!data || data.length === 0) {
	    	alert("No data to export");
	    	return;
	  	}
	  	const headers = Object.keys(data[0]);
	  	const rows = data.map(row =>
	    	headers.map(field => {
	      		let val = row[field];
	      		if (val === null || val === undefined) return "";
	      		val = val.toString().replace(/"/g, '""');
	      		return `"${val}"`;
	    	}).join(",")
	  	);
	  	const csvContent = [headers.join(","), ...rows].join("\n");
	  	const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
	  	const url = URL.createObjectURL(blob);
	  	const link = document.createElement("a");
	  	link.href = url;
	  	link.setAttribute("download", filename);
	  	document.body.appendChild(link);
	  	link.click();
	  	document.body.removeChild(link);
	  	URL.revokeObjectURL(url); // Clean up the object URL so subsequent clicks always work
	};

    const handleResize = () => {
    	const screenWidth = window.innerWidth;
        setScreenWidth(screenWidth);
		if (screenWidth > 750) { setDropdownVisible(false); }
	};

    const handleLogout = () => {
        localStorage.removeItem("authToken");
        sessionStorage.removeItem("shipments");
        navigate("/login");
    };

    const navItems = [
        { id: "new_button", label: "New" },
        { id: "export_button", label: "Export" },
        { id: "logout_button", label: "Log out" },
    ];

    const handleButtonClick = (label) => { setSelectedButton(label); }

    const toggleDropdown = () => { setDropdownVisible(prevState => !prevState); };
    
	return (
		<div className={`${styles.home_3pl_container} ${fontFamilyOne}`}>
			<Helmet>
                <title>Receiver</title>
            </Helmet>
			<div className={styles.logo_and_search_filter_row_container}>
			<Logo style={{ top: "10px", left: screenWidth < 580 ? "20px" : screenWidth < 1000 ? "80px" : "150px" }} />
				{revealReceiverTitle && (
					<div className={`${styles.receiver_title_container} fade_in`}>
						<img src={`${process.env.PUBLIC_URL}/business_images/${businessLogo}`} alt="Logo" className={`${styles.receiver_business_logo}`} />
						<p className={styles.receiver_title}>Returns Receiver</p>
					</div>
				)}
				{/* dropdown  */}
				<div className={styles.receiver_header_toggle_wrapper} onClick={toggleDropdown}>
		            {[...Array(3)].map((_, index) => (<div key={index} className="header_buttons_toggle_lines"></div>))}
		        </div>
				<div className={`${styles.receiver_header_buttons_dropdown}`} style={{ display: dropdownVisible ? "flex" : "none" }}>
                	{navItems.map((item) => (
                		<div key={item.id} className={`${styles.receiver_header_dropdown_buttons}`} onClick={() => {handleButtonClick(item.label); toggleDropdown()}}>
                			{item.label === "New" && <img src={`${process.env.PUBLIC_URL}/images/plus_symbol.png`} alt="Add Icon" className={styles.receiver_dropdown_search_icons} />}
      						{item.label === "Export" && <img src={`${process.env.PUBLIC_URL}/images/export_icon.png`} alt="Export Icon" className={styles.receiver_dropdown_search_icons} />}
                			{item.label}
                		</div>
                	))}
	      		</div>
	      		{/* 	*/}
	      		{revealHeaderButtons && (
					<div className={`fade_in ${styles.search_and_new_buttons_container}`}>
						<div className={styles.search_container}>
							<img src={`${process.env.PUBLIC_URL}/images/search_icon.png`} alt="Logo" className={`${styles.receiver_search_icons}`} />
							<input type="text" className={styles.search_input} placeholder="Search order or tracking #" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
						</div>
						<div className={styles.new_button} onClick={() => handleButtonClick("New")}>
							<img src={`${process.env.PUBLIC_URL}/images/plus_symbol.png`} alt="Add Icon" className={`${styles.receiver_search_icons}`} />
							<p className={styles.new_button_text}>New</p>
						</div>
						<div className={styles.new_button} onClick={() => exportToCSV(data)}>
							<img src={`${process.env.PUBLIC_URL}/images/export_icon.png`} alt="Export Icon" className={`${styles.receiver_search_icons}`} />
							<p className={styles.new_button_text}>Export</p>
						</div>
					</div>
				)}
				<div className={`${styles.log_out_button}`} onClick={() => handleLogout()}>Log out</div>
			</div>
			<ReturnsData rows={data} setRows={setData} token={token} apiUrl={apiUrl} searchValue={searchValue} selectedButton={selectedButton} setSelectedButton={setSelectedButton} font={fontFamilyOne} revealHeaderButtons={revealHeaderButtons} />
		</div>
	)	
}

export default HomePage3PL;